'use es6';

import { catchError } from 'rxjs/operators/catchError';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { of } from 'rxjs/observable/of';
import { startWith } from 'rxjs/operators/startWith';
import { CHANGED_CONTENT_AUDIENCE_ACCESS } from '../actions/ActionTypes';
import { receiveContent, requestChangeAudienceAccess, requestedChangeAudienceAccessFailure, requestedChangeAudienceAccessSuccess, requestedContentFailed, requestContent } from '../actions/ContentActions';
import { closeModal } from '../actions/ModalActions';
export default ((action$, _, {
  ContentClient
}) => action$.ofType(CHANGED_CONTENT_AUDIENCE_ACCESS).pipe(mergeMap(({
  payload: {
    id,
    contentType,
    audienceAccessType,
    numContactsFromLists,
    password,
    lists
  }
}) => ContentClient.changeAudienceAccess(contentType, id, audienceAccessType, password, lists).pipe(mergeMap(() => ContentClient.fetchContent({
  contentPageId: id,
  contentType
}).pipe(mergeMap(content => of(receiveContent(content), closeModal(), requestedChangeAudienceAccessSuccess({
  audienceAccessType,
  contentType,
  lists,
  numContactsFromLists
}))), catchError(error => of(requestedContentFailed(error))), startWith(requestContent()))), catchError(error => of(requestedChangeAudienceAccessFailure(error, contentType))), startWith(requestChangeAudienceAccess())))));